var exports = {
  "k": "xa15a2ab7--491379--container",
};

module.exports = exports;
